import React from 'react';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../../components';
import './landing.css';

/**
 * Customer landing page for the bare "/" route.
 *
 * The customer app is only ever reached via a QR-code deep link
 * (/user/dashboard/:token). Someone hitting the root URL directly has no venue
 * context, so instead of the old leftover owner-login form we show a friendly
 * "scan the QR code" explainer. Renders inside FrontLayout (logo + legal footer).
 */
const Landing = () => {
    const { t } = useTranslation();
    usePageTitle(t('landing.page_title'));

    return (
        <div className="mb-landing">
            <div className="mb-landing-badge" aria-hidden="true">{t('landing.scan_badge')}</div>
            <h1>{t('landing.heading')}</h1>
            <p>{t('landing.description')}</p>
            <ol className="mb-landing-steps">
                <li><span className="mb-landing-num">1</span> {t('landing.step1')}</li>
                <li><span className="mb-landing-num">2</span> {t('landing.step2')}</li>
                <li><span className="mb-landing-num">3</span> {t('landing.step3')}</li>
            </ol>
            <div className="mb-landing-note">{t('landing.powered_by')}</div>
        </div>
    );
}

export default Landing;
